import {ErrorDisplayProcessor} from '@dv5/components'
import {useAppDispatch} from '@dv5/domain'
import {FC, useEffect, useMemo, useState} from 'react'
import {searchApi, type SearchTaskResult} from '@dv5/api'
import './TaskPicker.less'

interface Props {
    onSelect: (task: SearchTaskResult) => void
    onCancel: () => void
}

export const TaskPicker: FC<Props> = ({onSelect, onCancel}) => {
    const dispatch = useAppDispatch()
    const [tasks, setTasks] = useState<SearchTaskResult[]>([])
    const [filter, setFilter] = useState('')
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false)

    useEffect(() => {
        let active = true
        searchApi.searchTasks('', new ErrorDisplayProcessor(dispatch)).then(result => {
            if (active) {
                setTasks(result)
                setLoading(false)
            }
        }).catch(() => {
            if (active) {
                setError(true)
                setLoading(false)
            }
        })
        return () => { active = false }
    }, [dispatch])

    const visible = useMemo(() => {
        const query = filter.toLocaleLowerCase()
        return tasks.filter(task => task.title.toLocaleLowerCase().includes(query))
    }, [tasks, filter])

    return <div className="task-picker-overlay" onMouseDown={e => e.stopPropagation()} onMouseUp={e => e.stopPropagation()} onClick={e => e.stopPropagation()} onKeyDown={e => { e.stopPropagation(); if (e.key === 'Escape') onCancel() }}>
        <div className="task-picker" role="dialog" aria-modal="true" aria-label="Choose task">
            <h3>Choose task</h3>
            <input autoFocus aria-label="Filter tasks by title" placeholder="Filter by title" value={filter} onChange={e => setFilter(e.target.value)}/>
            <div className="task-picker-list">
                {loading && <p>Loading tasks…</p>}
                {error && <p>Could not load tasks.</p>}
                {!loading && !error && visible.length === 0 && <p>{tasks.length ? 'No matching tasks.' : 'No tasks available.'}</p>}
                {visible.map(task => <button type="button" key={task.id} onClick={() => onSelect(task)}>
                    <strong>{task.title}</strong><span>{task.code}{task.status ? ` · ${task.status}` : ''}</span>
                </button>)}
            </div>
            <button type="button" onClick={onCancel}>Cancel</button>
        </div>
    </div>
}
